/**
 * Reglas de la ficha de una persona.
 *
 * Las dos son **conveniencia y no control**: el worker vuelve a decidir igual
 * (ADR 0019). Lo que evitan es ofrecer botones que el servidor va a rechazar,
 * que es peor experiencia que no ofrecerlos.
 */

/**
 * Si la cruz para quitar un rol se muestra.
 *
 * **El último rol no se quita.** El worker contesta 422 a una lista vacía, y
 * con razón: alguien adentro del sistema y sin ningún rol puede entrar y no
 * puede hacer nada, que es el peor de los dos estados — ni afuera ni adentro.
 */
export function sePuedeQuitar(rolesActuales: readonly string[], gestionable: boolean): boolean {
  return gestionable && rolesActuales.length > 1;
}

/**
 * Los roles que el selector ofrece: los asignables que la persona no tiene.
 *
 * `asignables` ya viene filtrado por contención desde `/roles-asignables`, así
 * que un rol que la persona tiene pero el actor no puede otorgar **no aparece**
 * — ni para agregar ni por estar puesto.
 */
export function rolesParaAgregar(
  asignables: readonly string[],
  rolesActuales: readonly string[],
): string[] {
  return asignables.filter((r) => !rolesActuales.includes(r));
}
